import React from "react";
import { cleanDate } from "../../../../util/app";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../StaffProfileCard";

const StaffLeaveItems = ({ items = [], onApprove, onDecline, onReturn }) => {
    if (items.length)
        return (
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th style={{ width: "5%" }} className="text-center">
                            SN
                        </th>
                        <th style={{ width: "20%" }}>Staff</th>
                        <th style={{ width: "10%" }}>Leave Date</th>
                        <th style={{ width: "10%" }}>Return Date</th>
                        <th style={{ width: "5%" }} className="text-center">
                            DAYS
                        </th>
                        <th style={{ width: "20%" }} className="text-center">
                            status
                        </th>
                        <th style={{ width: "20%" }}>note</th>
                        <th style={{ width: "10%" }} className="text-center">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className="text-center">
                                <strong>{index + 1}</strong>
                            </td>
                            <td>
                                <StaffProfileCard item={item.staff} />
                            </td>
                            <td>
                                {cleanDate(item.startDate, true)}
                                <br />
                                <span className="badge badge-primary">
                                    <TimeAgo date={item.startDate} />
                                </span>
                            </td>
                            <td>
                                {cleanDate(item.endDate, true)}
                                <br />
                                <span className="badge badge-primary">
                                    <TimeAgo date={item.endDate} />
                                </span>
                            </td>
                            <td className="text-center">
                                <strong>{item.days}</strong>
                            </td>
                            <td className="text-center">
                                {!item.onLeave && item.approved.status && (
                                    <>
                                        <span className="badge badge-success">Approved</span>
                                        <p>{item.approved.note}</p>
                                    </>
                                )}
                                {!item.onLeave && item.declined.status && (
                                    <>
                                        <span className="badge badge-danger">Declined</span>
                                        <p>{item.declined.note}</p>
                                    </>
                                )}

                                {!item.onLeave && !item.approved.status && !item.declined.status && <span className="badge badge-warning">waiting for Approval</span>}
                                {item.onLeave && <span className="badge badge-success">ON Leave</span>}
                                {!item.onLeave && item.returned.status && <span className="badge badge-primary">Returned</span>}
                            </td>
                            <td>{item.note || "No note"}</td>
                            <td className="text-center">
                                {!item.onLeave && !item.approved.status && !item.declined.status && (
                                    <>
                                        <button onClick={() => onApprove(item)} type="button" className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab margin-right-10" title="Approve">
                                            <i className="material-icons text-success">done_outline</i>
                                        </button>

                                        {/* Assign patients to item action button*/}
                                        <button onClick={() => onDecline(item)} type="button" className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab" title="Decline">
                                            <i className="material-icons text-danger">close</i>
                                        </button>
                                    </>
                                )}
                                {item.onLeave && (
                                    <button onClick={() => onReturn(item)} type="button" className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab" title="Return">
                                        <i className="material-icons text-primary">reply</i>
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );

    return (
        <>
            <div className="text-center">
                <h2 className="display-2">No Leave Yet!</h2>
                <p>You need to request a new leave</p>
            </div>
        </>
    );
};
export default StaffLeaveItems;
